import type { FaireProductEntity } from "../../entity_types/product";

export const p_jsqxh3zbaa: FaireProductEntity = {
  token: "p_jsqxh3zbaa",
  type: "product",
  name: "Calming Strategies",
  brandToken: "b_ebwob1e8ry",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/128c92ab8324d72459c1106f7a401f4204c8fda352885d5e20e4b6d74caea5df.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df8f4aae10df5e72aeec15f301229af0711ea040d6b919d0820c6b9e9ad5ae73.jpeg",
    "https://cdn.faire.com/fastly/7e367529f7bc34b983fcebc01b9532317234aa4e7f619a4247bad9c3e0297915.jpeg",
    "https://cdn.faire.com/fastly/b476de5e2b67e51cfbb31dfcde3ad6f0b751cf4fad8bea13e7504bae691c610a.jpeg",
  ],
  priceDollars: 3.47,
  description:
    "Make learning fun—anywhere, anytime—with Carson Dellosa's Be Clever Wherever preK—grade 5 Things on Rings Calming Strategies! This portable set for preschoolers through fifth graders is packed with everything you need to support positive thinking, methods of meditation, communication, and more. The set includes 16 vibrant, pre-punched reference cards on a book ring to reinforce essential social-emotional skills in a fun and engaging way from just about anywhere, including breathing techniques, yoga poses, basic calming strategies, and much more. Education happens everywhere, and Carson Dellosa strives to provide the tools needed to inspire learning everywhere it happens.",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:55.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
